<template>
  <div class="content if-profile report-tab">
    <div class="md-layout ratios-report">
      <MRReportHeader :headerData="this.headerData" />

      <div
        class="md-layout-item md-medium-size-100 md-xsmall-size-100  md-size-100 marketprof-competitors p-0 mt-4"
      >
        <div class="navbar md-toolbar md-transparent md-elevation-4 finanical-report-messages p-0">
          <nav-tabs-card no-label md-elevation="0">
            <template slot="content">
              <md-tabs md-alignment="left" class="if_card">
                <md-tab md-label="Volume" md-icon="equalizer" class="p-0">
                  <md-card class="m-0">
                    <md-card-header>Industry Market Volume</md-card-header>
                    <md-card-content>
                      <div class="md-layout p-4">
                        <div class="md-layout-item md-size-100 blue-tbl">
                          <md-card class="md-card-profile">
                            <md-card-header>
                              <h4 class="title m-0">
                                <div
                                  class="md-layout-item md-medium-size-100 md-size-100  card-title p-0"
                                >Industry Market Volume ($)</div>
                              </h4>
                              <!-- <h4 class="title text-left">
                                Industry Market Volume ($)
                              </h4>-->
                            </md-card-header>
                            <md-card-content>
                              <div class="md-layout">
                                <div
                                  class="md-layout-item md-medium-size-100 md-size-100 p-0 sub_table p-0 border-0"
                                >
                                  <md-table
                                    v-model="tableDataMarketVolume"
                                    table-header-color="blue"
                                    class="profit-and-loss-table"
                                  >
                                    <md-table-row slot="md-table-row" slot-scope="{ item }">
                                      <md-table-cell class="md-table-side-label">{{ item.name }}</md-table-cell>
                                      <md-table-cell
                                        v-for="key in Object.keys(item.dates)"
                                        :key="key"
                                        :md-label="years[key]"
                                      >{{ item.dates[key] }}</md-table-cell>
                                    </md-table-row>
                                  </md-table>
                                </div>
                              </div>
                            </md-card-content>
                          </md-card>
                        </div>
                        <div class="md-layout-item md-medium-size-100 md-size-50">
                          <md-card class="md-card-profile">
                            <md-card-content>
                              <chart-card
                                header-animation="false"
                                :chart-data="marketVolumeChart.data"
                                :chart-options="marketVolumeChart.options"
                                chart-type="Line"
                                header-icon
                                chart-inside-content
                                no-footer
                                background-color="blue"
                              >
                                <template slot="chartInsideHeader">
                                  <h4 class="title m-0">
                                    <div
                                      class="md-layout-item md-medium-size-100 md-size-100 card-title p-0"
                                    >Industry Market Volume($)</div>
                                  </h4>
                                  <!-- <h4 class="title">Industry Market Volume($)</h4> -->
                                </template>
                              </chart-card>
                               <div class="pie-line">
                                  <ul>
                                    <li><span class=""><i class="fa fa-square sky-blue-color"></i></span> Industry</li>
                                      <li><span class=""><i class="fa fa-square red-color"></i></span> Small Business</li>
                                      <li><span class=""><i class="fa fa-square yellow-color"></i></span> Startup</li>

                                  </ul>
                                    </div>
                            </md-card-content>
                          </md-card>
                        </div>
                          <div class="md-layout-item md-medium-size-100 md-size-50">
                              <!-- <md-card class="md-card-profile">
                                <md-card-header>
                                  <h4 class="title m-0">
                                    <div
                                      class="md-layout-item md-medium-size-100 md-size-100 card-title p-0"
                                    >
                                      Competitive Market Narrative
                                    </div>
                                  </h4>
                                </md-card-header>
                                <md-card-content>
                                  <div class="extra_space">
                                    <p>
                                      {{cmnText.market.share}}
                                    </p>
                                  </div>
                                </md-card-content>
                              </md-card> -->
                              <md-card class="md-card-profile ">
                                <md-card-header>
                                  <h4 class="title m-0">
                                    <div
                                      class="md-layout-item md-medium-size-100 md-size-100 card-title p-0"
                                    >
                                      <md-icon class="color-white">article</md-icon> Industry Market Volume
                                    </div>
                                  </h4>
                                </md-card-header>
                                <md-card-content>
                                  <div class="md-layout">
                                    <div class="md-layout-item md-medium-size-100 md-size-100">
                                      <div class="extra_space">
                                        <p>
                                         {{cmnText.market.volume}}
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                </md-card-content>
                              </md-card>
                            </div>
                            <div class="md-layout-item md-medium-size-100 md-size-50">

                            </div>
                      </div>
                    </md-card-content>
                  </md-card>
                </md-tab>
                <md-tab md-label="Share" md-icon="bubble_chart" class="p-0">
                  <md-card class="m-0">
                    <md-card-header>Industry Market Share</md-card-header>
                    <md-card-content>
                      <div class="md-layout p-4">
                        <div class="md-layout-item md-size-100 blue-tbl">
                          <md-card class="md-card-profile">
                            <md-card-header>
                              <h4 class="title m-0">
                                <div
                                  class="md-layout-item md-medium-size-100 md-size-100 card-title p-0"
                                >Industry Market Share (%)</div>
                              </h4>
                              <!-- <h4 class="title text-left">
                                Industry Market Share (%)
                              </h4>-->
                            </md-card-header>
                            <md-card-content>
                              <div class="md-layout">
                                <div
                                  class="md-layout-item md-medium-size-100 md-size-100 sub_table p-0 border-0"
                                >
                                  <md-table
                                    v-model="tableDataMarketShare"
                                    table-header-color="blue"
                                    class="profit-and-loss-table"
                                  >
                                    <md-table-row slot="md-table-row" slot-scope="{ item }">
                                      <md-table-cell class="md-table-side-label">{{ item.name }}</md-table-cell>
                                      <md-table-cell
                                        v-for="key in Object.keys(item.dates)"
                                        :key="key"
                                        :md-label="years[key]"
                                      >{{ item.dates[key] }}</md-table-cell>
                                    </md-table-row>
                                  </md-table>
                                </div>
                              </div>
                            </md-card-content>
                          </md-card>
                        </div>
                        <div class="md-layout-item md-medium-size-100 md-size-50">
                          <md-card class="md-card-profile">
                            <md-card-content>
                              <chart-card
                                header-animation="false"
                                :chart-data="marketShareChart.data"
                                :chart-options="marketShareChart.options"
                                chart-type="Line"
                                header-icon
                                chart-inside-content
                                no-footer
                                background-color="blue"
                              >
                                <template slot="chartInsideHeader">
                                  <h4 class="title m-0">
                                    <div
                                      class="md-layout-item md-medium-size-100 md-size-100 card-title p-0"
                                    >{{ years[years.length - 1] }} Industry Market Share (%)</div>
                                  </h4>
                                  <!-- <h4 class="title">
                                    Mar-2021 Industry Market Share (%)
                                  </h4>-->
                                </template>
                              </chart-card>
                               <div class="pie-line">
                                <ul>
                                  <li><span class=""><i class="fa fa-square sky-blue-color"></i></span> Industry</li>
                                    <li><span class=""><i class="fa fa-square red-color"></i></span> Small Business</li>
                                    <li><span class=""><i class="fa fa-square yellow-color"></i></span> Startup</li>
                                     <li><span class=""><i class="fa fa-square blue-color"></i></span> Your Firm</li>
                                </ul>
                                    </div>
                            </md-card-content>
                          </md-card>
                        </div>
                            <div class="md-layout-item md-medium-size-100 md-size-50">
                              <md-card class="md-card-profile">
                                <md-card-header>
                                  <h4 class="title m-0">
                                    <div
                                      class="md-layout-item md-medium-size-100 md-size-100 card-title p-0"
                                    >
                                      Competitive Market Narrative
                                    </div>
                                  </h4>
                                </md-card-header>
                                <md-card-content>
                                  <div class="extra_space">
                                    <!-- <h4 class="Performance Scores">
                                      Competitive Market Narrative
                                    </h4> -->
                                    <p>
                                      The small business market share of total
                                      industry market volume is 49.75%, down
                                      from 2015 levels. Startup share is 1.00%.
                                      <br />
                                      <br />
                                      Market volume and average firm sales
                                      calculations are developed with firm-level
                                      data which is integrated with Bizminer's
                                      internally generated Sales per Employee
                                      projections. SPE data is both industry-
                                      and location-specific, and is updated
                                      monthly by the application of US Census
                                      data and five industry and consumer price
                                      and productivity indices from the Bureau
                                      of Labor Statistics and other federal
                                      agencies.​
                                    </p>
                                  </div>
                                </md-card-content>
                              </md-card>
                            </div>
                            <div class="md-layout-item md-medium-size-100 md-size-50">
                              <md-card class="md-card-profile ">
                                <md-card-header>
                                  <h4 class="title m-0">
                                    <div
                                      class="md-layout-item md-medium-size-100 md-size-100 card-title p-0"
                                    >
                                      <md-icon class="color-white">article</md-icon> Industry Market Share
                                    </div>
                                  </h4>
                                </md-card-header>
                                <md-card-content>
                                  <div class="md-layout">
                                    <div class="md-layout-item md-medium-size-100 md-size-100">
                                      <div class="extra_space">
                                        <p>
                                          What is the small business share of total industry market?
                                          What portion is held by startups? And (if you made the necessary input) by your firm?
                                          Shares are expressed as a percent of the total.<br><br>The small business market share represents only
                                          those firms fewer than 25 employees. Startup market share is calculated for firms which have
                                          been in operation for less than two years. <br><br> Market volume and average firm sales
                                          calculations are developed with firm-level data which is integrated with BizMiner's internally
                                          generated Sales per Employee projections. SPE data is both industry- and location-specific,
                                          and is updated monthly by the application of US Census data and five industry and consumer
                                          price and productivity indices from the Bureau of Labor Statistics and other federal agencies.
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                </md-card-content>
                              </md-card>
                            </div>
                      </div>
                    </md-card-content>
                  </md-card>
                </md-tab>
              </md-tabs>
            </template>
          </nav-tabs-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ChartCard, NavTabsCard } from '@/components';
import { mapState } from 'vuex';
import MRReportHeader from './_partials/MRReportHeader.vue';

export default {
  components: {
    ChartCard,
    NavTabsCard,
    MRReportHeader,
  },
  props: ['headerData'],
  data() {
    return {
      view: 'cash-flow-solvency',
      showDialog: false,
      marketVolumeChart: {
        data: {
          labels: [],
          series: [],
        },
        options: {
          lineSmooth: this.$Chartist.Interpolation.cardinal({
            tension: 10,
          }),
          axisY: {
            showGrid: true,
            offset: 40,
          },
          axisX: {
            showGrid: false,
          },
          low: 0,
          showPoint: true,
          height: '300px',
        },
      },
      marketShareChart: {
        data: {
          labels: [],
          series: [],
        },
        options: {
          layout: {
            padding: {
              left: 200,
              right: 200,
            },
          },
          lineSmooth: this.$Chartist.Interpolation.cardinal({
            tension: 10,
          }),
          axisY: {
            showGrid: true,
            offset: 40,
          },
          axisX: {
            showGrid: false,
          },
          low: 0,
          showPoint: true,
          height: '300px',
        },
      },

      tableDataMarketVolume: [],
      tableDataMarketShare: [],
    };
  },
  computed: {
    ...mapState({
      marketReport: (state) => state.user.market_report,
      marketVolume: (state) =>
        state.user.market_report.data.data['marketVolume'],
      marketShare: (state) => state.user.market_report.data.data['marketShare'],
      years: (state) => state.user.market_report.data.years,
      cmnText: (state) =>state.user.market_report.cmnText,
    }),
  },
  mounted() {
    let section = this.$route.query.section;

    if (!section) {
      section = 'cash-flow-solvency';
    }

    this.switchView(section);

    this.tableDataMarketVolume = Object.entries(
      this.marketVolume
    ).map(([table, data]) => ({ name: table, dates: Object.values(data) }));
    this.tableDataMarketShare = Object.entries(
      this.marketShare
    ).map(([table, data]) => ({ name: table, dates: Object.values(data) }));

    let me = this;
    this.tableDataMarketVolume.map((item) => {
      item.dates = item.dates.map((e) => {
        return me.numberWithCommas(e);
      });
      return item;
    });
    let newTableMarketVolume = Object.entries(
      this.marketVolume
    ).map(([table, data]) => ({ name: table, dates: Object.values(data) }));
    let newTableMarketShare = Object.entries(
      this.marketShare
    ).map(([table, data]) => ({ name: table, dates: Object.values(data) }));
    newTableMarketVolume.map((item) => {
      item.dates = item.dates.map((e) => {
        return Number(e) / 1000000;
      });
      return item;
    });
    this.marketVolumeChart.data = {
      labels: this.years,
      series: newTableMarketVolume.map((item) => ({
        name: item.name,
        data: item.dates,
      })),
    };

    this.marketShareChart.data = {
      labels: this.years,
      series: newTableMarketShare.map((item) => ({
        name: item.name,
        data: item.dates.map((i) => Number(i)),
      })),
    };
  },
  watch: {
    '$route.query.section'() {
      let section = this.$route.query.section;

      if (!section) {
        section = 'cash-flow-solvency';
      }

      this.switchView(section);
    },
  },
  methods: {
    switchView: function (type) {
      this.view = type;
    },
    numberWithCommas(x) {
      if (x) {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      } else {
        return x;
      }
    },
  },
};
</script>
<style lang="scss">
.marketprof-competitors {
  .md-toolbar {
    .md-collapse {
      display: block;

      .md-collapse-content {
        p {
          padding-left: 20px;
        }
      }
    }
  }

  .competitors-list {
    .md-collapse-title {
      font-size: 12px;
      font-weight: 300;
      margin-left: 25px;
    }
    .md-icon {
      font-size: 12px;
      font-weight: 300;
      transform: rotate(-90deg);
      left: 0;
      color: rgba(0, 0, 0, 0.54);
    }
  }

  .competitors-map {
    iframe {
      height: 300px !important;
    }
  }
}
</style>
